// src/metrics/routes.ts
import { ROUTES } from 'configs/routeConstants';

/** нормализация пути (убираем конечный слэш кроме корня) */
const norm = (p: string) => (p !== '/' ? p.replace(/\/+$/, '') : p);

/** Человекочитаемые названия страниц для параметра `source` */
export const ROUTE_SLUGS: Record<string, string> = {
  [norm(ROUTES.root)]: 'main_page',

  [norm(ROUTES.signin)]: 'signin',
  [norm(ROUTES.signup)]: 'signup',
  [norm(ROUTES.signupSuccess)]: 'signup_success',

  [norm(ROUTES.forgotPassword)]: 'forgot_password',
  [norm(ROUTES.resetPassword)]: 'reset_password',

  [norm(ROUTES.faq)]: 'faq',
  [norm(ROUTES.documents)]: 'documents',
  [norm(ROUTES.contacts)]: 'contacts',
  [norm(ROUTES.info)]: 'info',

  [norm(ROUTES.questionnaire)]: 'questionnaire',
  [norm(ROUTES.checkup)]: 'checkup',

  [norm(ROUTES.privacyPolicy)]: 'privacy_policy',
  [norm(ROUTES.personalDataPolicy)]: 'personal_data_policy',

  // profile
  [norm(ROUTES.profile.root)]: 'profile_main',
  [norm(ROUTES.profile.security)]: 'profile_security',
  [norm(ROUTES.profile.notifications)]: 'profile_notifications',
  [norm(ROUTES.profile.support)]: 'profile_support',

  // my-health
  [norm(ROUTES.myHealth.root)]: 'my_health_main',
  [norm(ROUTES.myHealth.analysis)]: 'my_health_analysis',
  [norm(ROUTES.myHealth.program)]: 'my_health_program',
  [norm(ROUTES.myHealth.training)]: 'my_health_training',
  [norm(ROUTES.myHealth.nutrition)]: 'my_health_nutrition',
  [norm(ROUTES.myHealth.vitamins)]: 'my_health_vitamins',
  [norm(ROUTES.myHealth.statistics)]: 'my_health_statistics',
  [norm(ROUTES.myHealth.skinAnalysis)]: 'my_health_skin_analysis',
};

/** Получить slug для текущего pathname */
export const getPageSlug = (pathname: string): string => {
  const p = norm(pathname);
  return ROUTE_SLUGS[p] ?? p; // если нет в карте — отдадим сам путь
};
